import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import AppContext from "../../contexts/AppContext";

class ErrorHandler extends Component {

    static contextType = AppContext;

    constructor(props, context) {
        super(props, context);

        const {setError} = this.context;

        this.onRouteChange = this.onRouteChange.bind(this);

        // Set axios interceptors
        // this.requestInterceptor = axios.interceptors.request.use(request => {
        //     return request;
        // });

        this.responseInterceptor = axios.interceptors.response.use(
            response => {
                return response;
            },
            error => {
                const errData = error.response !== undefined ? error.response.data : {};

                if (errData.code !== undefined && errData.code !== 422) {
                    setError({message: errData});
                } else if (errData.message === 'CSRF token mismatch.' && error.response.status === 419) {
                    axios.get('/api/refresh_csrf_token')
                        .then(
                            response => {
                                error.config.headers['X-CSRF-TOKEN'] = response.data;
                                window.axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data;

                                return axios.request(error.config);
                            }
                        );
                }

                return Promise.reject(error);
            }
        );
    }

    componentDidMount() {
        this.props.history.listen(this.onRouteChange);
    }

    componentWillUnmount() {
        // Remove handlers, so Garbage Collector will get rid of if WrappedComponent will be removed
        axios.interceptors.request.eject(this.requestInterceptor);
        axios.interceptors.response.eject(this.responseInterceptor);
    }

    onRouteChange() {
        const {clearError} = this.context;
        clearError();
    }

    render() {
        const {children} = this.props;

        return children;
    }
}

export default withRouter(ErrorHandler);
